export default {
  editar: "Edit",
  eliminar: "Delete",
  confirmar: "Confirm",
  cancelar: "Cancel",
  cerrar: "Close",
  guardar: "Save",
  noData: "No data found",
  renovar: "Renew",
  comprar: "Buy",
  volver: "Back",
  limpiarFiltros: "Clear filters",
  imprimir: "Print",
  exportar: "Export to Excel",
  filtrar: "Filter",
  si: "Yes",
  no: "No",
  todos: "All",
  descargar: "Download",
  ninguno: "None",
  msgError: "An error has occurred",
  msgExito: "The operation was completed successfully",
  noDefinido: "Not defined",
  msgOrdenFinalizada: "Action cannot be completed because the order has been finalized",
  continuar: "Continue",
  msgNroInvalido: "Please enter a valid number",
  msgCampoRequerido: "Please complete all required fields",
  verDetalle: "View details",
  msgEspera: "Please wait...",
  seleccionar: "Select",
  seleccionado: "Selected",
  monedaNacional: "Local Currency",
  dolares: "Dollars",
  "Moneda Nacional": "Local Currency",
  Dolares: "Dollars",
  msgImagenInvalida: "Invalid image format, only .png, .jpg or .jpeg are allowed",
  msgErrorEmailDuplicado: "A client with this email already exists in this account",
  msgSeleccioneOpcion: "You must select an option",
  generar: "Generate",
  linkTerminos: "https://satweb.us/terminos-de-uso"
}
